import { render, staticRenderFns } from "./NuevoEmpleado.vue?vue&type=template&id=0f29c9f8&scoped=true&"
import script from "./NuevoEmpleado.vue?vue&type=script&lang=js&"
export * from "./NuevoEmpleado.vue?vue&type=script&lang=js&"
import style0 from "./NuevoEmpleado.vue?vue&type=style&index=0&id=0f29c9f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29c9f8",
  null
  
)

export default component.exports